import classNames from 'classnames';
import { type ComponentProps, type CSSProperties, memo } from 'react';

import { CustomFieldDisplay } from '~/components/CustomFieldDisplay';
import { type AssignedCustomFieldValue } from '~/swr-hooks/customFields/types';

type CustomFieldsDisplay = {
  className?: ComponentProps<'button'>['className'];
  style?: CSSProperties;
  customFields: AssignedCustomFieldValue[];
  onClick?: () => void;
  shouldShowLabelInline?: boolean;
};
export const CustomFieldsDisplay = memo(
  ({ className, customFields, onClick, shouldShowLabelInline, style }: CustomFieldsDisplay) => {
    return (
      <button
        data-testid="CUSTOM_FIELDS_INDICATOR"
        className={classNames(
          'pointer-events-auto flex max-w-full flex-col gap-1 text-left hover:bg-transparent',
          className,
        )}
        disabled={!onClick}
        onClick={onClick}
        style={style}
        type="button"
      >
        {customFields.map((cfValue) => (
          <CustomFieldDisplay shouldShowLabelInline={shouldShowLabelInline} key={cfValue.id} cfValue={cfValue} />
        ))}
      </button>
    );
  },
);

CustomFieldsDisplay.displayName = 'CustomFieldsDisplay';
